<template>
  <li class="py-7" :class="registrationTrack ? '' : 'add-on-item'">
    <EditAddOnItem
      v-if="item.isEditMode"
      :item="item"
      :registrationTrack="registrationTrack"
    />
    <PreviewAddOnItem v-else-if="!registrationTrack" :item="item" />
  </li>
</template>

<script>
import EditAddOnItem from "./EditAddOnItem";
import PreviewAddOnItem from "./PreviewAddOnItem";

export default {
  name: "AddOnItem",
  components: {
    EditAddOnItem,
    PreviewAddOnItem
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    registrationTrack: {
      type: Boolean,
      required: false
    }
  }
};
</script>

<style scoped>
.add-on-item:not(:last-of-type) {
  position: relative;
}
.add-on-item:not(:last-of-type):after {
  content: "";
  position: absolute;
  bottom: 0;
  left: -20px;
  right: -20px;
  height: 1px;
  background-color: var(--divider-color);
}
</style>
